"use client";
import { useCallback, useState } from 'react';
import { CheckboxItem, FilterGroups } from '../../Filters';
import style from './filterBasicGroup.module.scss';
import Minus from '@/projectRoot/src/components/common/svg/Minus';
import Plus from '@/projectRoot/src/components/common/svg/Plus';
import { useFilters } from '@/projectRoot/src/contexts/FiltersContext';
import LinkUrl from '@/projectRoot/src/components/common/general/link/LinkUrl';
import { useParams } from 'next/navigation';
import { useLocale, useTranslations } from 'use-intl';

interface Props {
    title: string;
    name: FilterGroups;
    items: CheckboxItem[];
    opened: boolean;
    openGroup: () => void;
    classes?: string[];
    display: 'text' | 'box'
}

const FilterBasicGroup = ({title, name, items, openGroup, opened, classes = [], display}: Props) => {
    const [counter, setCounter] = useState<number>(0);
    const {state, dispatch} = useFilters();
    const params = useParams();
    const t = useTranslations();
    const locale = useLocale();
    
    const dispatchFilters = useCallback((param: string) => {
        switch (name) {
            case FilterGroups.CATEGORIES:
                dispatch({ type: "updateCategories", payload: param });
                break;
            case FilterGroups.COLLECTIONS:
                dispatch({ type: "updateCollections", payload: param });
                break;
            case FilterGroups.LABELS:
                dispatch({ type: "updateLabels", payload: param });
                break;
            case FilterGroups.SIZES:
                dispatch({ type: "updateSizes", payload: param });
                break;
            case FilterGroups.COLORS:
                dispatch({ type: "updateColors", payload: param });
                break;
            default:
                break;
        }
    }, [state]);

    const createHref = (id: string) => {
        let href = '';
        switch (name) {
            case FilterGroups.CATEGORIES:
                href = `/${locale}/${t('RoutesTranslations.categories').toLocaleLowerCase()}/${id}`;
                break;
            case FilterGroups.COLLECTIONS:
                href = `/${locale}/${t('RoutesTranslations.collections').toLocaleLowerCase()}/${id}`;
                break;
            case FilterGroups.LABELS:
                href = `/${locale}/${t('RoutesTranslations.labels').toLocaleLowerCase()}/${id}`;
                break;
            case FilterGroups.SIZES:
                href = `/${locale}/${t('RoutesTranslations.sizes').toLocaleLowerCase()}/${id}`;
                break;
            case FilterGroups.COLORS:
                href = `/${locale}/${t('RoutesTranslations.colors').toLocaleLowerCase()}/${id}`;
                break;
            default:
                break;
        }
        return href;
    } 

  return (
    <div className={`${style.filterCheckboxWrapper} ${opened ? style.opened : ''} ${classes.join(' ')}`}>
        <div className={`${style.filterCheckboxHeader} ${counter > 0 ? style.checked : ''}`} onClick={() => openGroup()}>
            <div className={style.title}>
                {title}
                {
                    counter > 0
                        ?
                        <span className={style.counter}>[{counter}]</span>
                        : <></>
                }
            </div>
            <span className={style.dropdown}>
                {
                    opened ? <Minus /> : <Plus />
                }
            </span>
        </div>
        <div className={`${style.options} ${style[display]}`}>
            {
                items.map((item: CheckboxItem, index) => {
                    return (
                        display == 'text'
                        ?
                        <div key={item.id}>
                            <LinkUrl 
                                classes={[`${style.option} ${params.id == item.id ? style.active : ''}`]}
                                // onClick={() => dispatchFilters(item.id)}
                                noLink={params.id == item.id}
                                text={item.title}
                                url={createHref(item.id)}
                            />
                            <div className={style.submenu}>
                                {
                                    item.children && item.children.length > 0
                                    ?
                                    item.children.map(child => {
                                        return (
                                            <div key={child.id}>
                                                <LinkUrl 
                                                    key={child.id} 
                                                    classes={[`${style.option} ${params.id == child.id ? style.active : ''}`]}
                                                    // onClick={() => dispatchFilters(child.id)}
                                                    noLink={params.id == child.id}
                                                    text={child.title}
                                                    url={createHref(child.id)}
                                                />
                                                <div className={style.submenu}>
                                                    {
                                                        child.children && child.children.length > 0
                                                        ?
                                                        child.children.map(grandchild => {
                                                            return (
                                                                <LinkUrl 
                                                                    key={grandchild.id} 
                                                                    classes={[`${style.option} ${params.id == grandchild.id ? style.active : ''}`]}
                                                                    // onClick={() => dispatchFilters(grandchild.id)}
                                                                    noLink={params.id == grandchild.id}
                                                                    text={grandchild.title}
                                                                    url={createHref(grandchild.id)}
                                                                />
                                                            )
                                                        })
                                                        : <></>
                                                    }
                                                </div>
                                            </div>
                                        )
                                    })
                                    :
                                    <></>
                                }
                            </div>
                        </div>
                        :
                        <span 
                            key={item.id} 
                            className={`${style.option} ${state[name]?.includes(item.id) ? style.active : ''}`}
                            onClick={() => dispatchFilters(item.id)}
                        >
                            {item.title}
                        </span>
                    )
                })
            }
        </div>
    </div>
  )
};

export default FilterBasicGroup;
